<template>
  <div>
    <StartCn :handler="handler" v-if="is_CN" v-bind="$attrs" />
    <StartEn v-else v-bind="$attrs" />
  </div>
</template>

<script setup lang="ts">
import StartCn from './start-cn.vue';
import StartEn from './start-en.vue';

defineProps<{
  handler: () => void;
}>();

const is_CN = computed(() => {
  return isChinese();
});
</script>

<style lang="scss"></style>
